<template>
  <div class="main_wrap container">
    <Breadcrumbs :item="item" :type="'skin'" />

    <div class="skin_wrap">
      <div class="skin_lside">
        <LazyPagesItemComponentsVariables
            v-if="item.volume?.length"
            :item="item"
            :variables="item.volume as Volume[]"
        />
        <LazyPagesItemComponentsPhases
            v-if="item.phases?.length"
            :active-item-name="item.market_hash_name"
            :phases="item.phases as PhaseItem[]"
        />
        <LazyPagesItemComponentsColors
            v-if="item.colors?.length"
            :colors="(item.colors || []) as Color[]"
            :countItems="(item.colorItemCount || []) as ColorItemCount[]"
        />
        <LazyPagesItemComponentsCaseItems
            v-if="item.contains?.length"
            :category="item.category || ''"
            :count="item.contains.length"
            :items="item.contains as ContainerItem[]"
            :link="item.link"
            :name="item.market_hash_name"
            :title="$t('Container items')"
        />
        <LazyPagesItemComponentsSlider
            v-if="item.crates?.length"
            :cases="item.crates as CratesItem[]"
            :title="$t('Containers')"
        />

        <!--        <div v-intersect="{callback: () => showedElements.collection = true}"></div>-->

        <!--        <client-only v-if="showedElements.collection">-->
        <LazyPagesItemComponentsSlider
            v-if="item.collection"
            :cases="[{market_hash_name: item.collection}] as CratesItem[]"
            :title="$t('Collections')"
            is-collection
        />
        <!--          <div v-intersect="{callback: () => showedElements.sales_history = true}"></div>-->
        <!--        v-if="showedElements.sales_history"-->
        <!--        <template>-->
        <!--        <client-only>-->
        <LazyPagesItemComponentsStatAside
            v-if="hasStatistics"
            :item="item"
        />
        <!--        </client-only>-->
        <PagesItemComponentsShortInfo :item="item" />
        <LazyPagesItemComponentsProPlayers
            v-if="item.pro_players?.length"
            :players="(item.pro_players || []) as ItemPageProPlayer[]"
        />

        <!--                    <LazyPagesItemComponentsSmallCards-->
        <!--                        v-if="players && players.length"-->
        <!--                        :items="players"-->
        <!--                        :title="$t('Professional Players')"-->
        <!--                    />-->
        <!--        </template>-->
        <!--        </client-only>-->
      </div>

      <div class="skin_rside">
        <PagesItemComponentsMainInfo :item="item" />
        <LazyPagesItemComponentsVariables
            v-if="item.volume?.length"
            :item="item"
            :variables="item.volume as Volume[]"
            class="hlgt"
        />
        <LazyPagesItemComponentsOffers
            v-if="item.markets_offers?.length"
            :markets="item.markets_info as MarketInfo[]"
            :name="item.market_hash_name"
            :offers="item.markets_offers as MarketOffer[]"
        />

        <client-only>
          <div v-intersect="{callback: () => showedElements.chart = true}"
          ></div>
        </client-only>
        <LazyPagesItemComponentsChart
            v-if="showedElements.chart"
            :item="item"
            :loading-prop="loading"
        />
        <section
            v-if="showedElements.chart && item.item_max_float"
        >
          <h2>{{ t('wear_range') }}</h2>
          <LazyPagesItemComponentsImageFloatRange
              :inputName="`https://images.csmarketcap.com/exterior-viewer/${
               getModifiedString(getItemNameWithCategoryLocal(item.market_hash_name.replace(/Souvenir|StatTrak/g, '').replace(/Doppler.*/, 'doppler')))
             }`"
              :max="item.item_max_float || 1"
              :min="item.item_min_float || 0.01"
          />
        </section>
        <div class="hlgt">
          <LazyPagesItemComponentsCaseItems
              v-if="item.contains?.length"
              :category="item.category || ''"
              :count="item.contains.length"
              :items="item.contains as ContainerItem[]"
              :link="item.link"
              :name="item.market_hash_name"
              :title="$t('Container items')"
          />
          <LazyPagesItemComponentsPhases
              v-if="item.phases?.length"
              :active-item-name="item.market_hash_name"
              :phases="item.phases as PhaseItem[]"
          />
          <LazyPagesItemComponentsColors
              v-if="item.colors?.length"
              :colors="(item.colors || []) as Color[]"
              :countItems="(item.colorItemCount || []) as ColorItemCount[]"
          />
          <!--          <client-only>-->
          <LazyPagesItemComponentsStatAside
              v-if="hasStatistics"
              :item="item"
          />
          <!--          </client-only>-->
          <!--          <LazyPagesItemComponentsInspect-->
          <!--              v-if="false" :item="item.descriptions"-->
          <!--          />-->
          <LazyPagesItemComponentsSlider
              v-if="item.crates?.length"
              :cases="item.crates as CratesItem[]"
              :title="$t('Containers')"
          />
          <LazyPagesItemComponentsSlider
              v-if="item.collection"
              :cases="[{market_hash_name: item.collection}] as CratesItem[]"
              :title="$t('Collections')"
              is-collection
          />
          <PagesItemComponentsShortInfo :item="item" />
          <LazyPagesItemComponentsProPlayers
              v-if="item.pro_players?.length"
              :players="(item.pro_players || []) as ItemPageProPlayer[]"
          />
        </div>
        <!--        </client-only>-->

        <!--        <div v-intersect="{callback: () => showedElements.similar = true}"-->
        <!--        ></div>-->
        <!--        v-if="showedElements.similar"-->
        <!--        <client-only>-->
        <!--        <client-only>-->
        <LazyPagesItemComponentsSimilar
            v-if="item.family_skins?.length"
            :items="item.family_skins as FamilySimilarSkins[]"
            title="family_skins"
        />
        <LazyPagesItemComponentsSimilar
            v-if="item.similar_skins?.length"
            :items="item.similar_skins as FamilySimilarSkins[]"
            title="similar_skins"
        />
        <NuxtLink
            v-if="item.similar_skins?.length"
            :to="getWeaponLink(item.weapon || item.category)"
            class="btn btn-primary w320 show-more-btn"
        >
          {{ $t('Show all') }}
        </NuxtLink>
        <!--        </client-only>-->

        <!--        <client-only>-->
        <!--          <LazyPagesItemComponentsSmallCards-->
        <!--              v-if="players && players.length"-->
        <!--              :items="players"-->
        <!--              :title="$t('Professional Players')"-->
        <!--          />-->
        <!--        </client-only>-->
        <LazyPagesItemComponentsDescriptions
            :item="item"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {useI18n} from 'vue-i18n'
import {useResize} from '~/composables/resize'
import type {
  Color,
  ColorItemCount,
  ContainerItem,
  CratesItem,
  FamilySimilarSkins,
  ItemPageInfo,
  ItemPageProPlayer,
  MarketInfo,
  MarketOffer,
  PhaseItem,
  Volume
} from "~/graphql/generated/schema-types";

const props = defineProps<{
  item: ItemPageInfo
  loading: boolean
}>()

const {t} = useI18n()
const currW = useResize()

const showedElements = ref({
  chart: false,
  similar: false,
  family: false,
  sales_history: false,
  offers: false,
  collection: false
})

const hasStatistics = computed(() => {
  return props.item.chart?.length ||
      props.item.price_statistics?.seven_day_chart?.length ||
      Object.keys(props.item.price_statistics || {}).some(i => !!props.item.price_statistics?.[i as keyof typeof props.item.price_statistics])
})

function getItemNameWithCategoryLocal(name: string) {
  if (!name) return "";

  return name
      .replace(/\s*\((Factory New|Minimal Wear|Field-Tested|Well-Worn|Battle-Scarred)\)\s*$/i, "") // убираем только состояние
      .replace(/\s*\|\s*/g, "-") // заменяем разделитель
      .replace(/\s+/g, "-") // пробелы — в тире
      .toLowerCase();
}
</script>

<style lang="scss" scoped>

.main_wrap {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.skin_wrap {
  .skin_lside {
    display: none;
  }

  @media screen and (min-width: 1115px) {
    display: flex;
    gap: 32px;
    align-items: flex-start;
    .skin_lside {
      display: block;
    }
  }
}
</style>

<style lang="scss">
.skin {
  section {
    margin: 3.2rem 0;

    &.skin-main {
      margin-top: 0;
    }
  }

  .skin-title, h2 {
    font-size: 2rem;
    margin-bottom: 2rem;
    font-weight: 600;
  }

  &_lside {
    min-width: 28rem;
    width: 28rem;
  }

  &_rside {
    flex-grow: 1;
  }

  .show-more-btn {
    height: 4.4rem;
    margin: 0 auto;
  }

  @media screen and (max-width: 1115px) {
    section.skin-main {
      margin-top: 1.6rem;
    }
  }
}
</style>
